import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'admin-planning-container',
  templateUrl: './admin-planning-container.component.html',
  styleUrls: ['./admin-planning-container.component.scss']
})
export class AdminPlanningContainerComponent implements OnInit {
  private static readonly SELECTED_COMPONENT_KEY =
    'admin-planning-selected-component';
  private static readonly SELECTED_COMPONENT_OPTIONS = [
    'daily-planning-overview',
    'admin-planning-map'
  ];
  private static readonly HIDE_PLANNED_PROJECTS_KEY =
    'admin-planning-hide-planned';

  selectedComponent: string;
  hidePlannedProjects: boolean;

  ngOnInit(): void {
    this.initializeSelectedComponent();
    this.initializeHidePlannedProjects();
  }

  private initializeSelectedComponent(): void {
    this.selectedComponent = localStorage.getItem(
      AdminPlanningContainerComponent.SELECTED_COMPONENT_KEY
    );
    if (
      this.selectedComponent == null ||
      !AdminPlanningContainerComponent.SELECTED_COMPONENT_OPTIONS.includes(
        this.selectedComponent
      )
    ) {
      this.selectedComponent =
        AdminPlanningContainerComponent.SELECTED_COMPONENT_OPTIONS[0];
      localStorage.setItem(
        AdminPlanningContainerComponent.SELECTED_COMPONENT_KEY,
        this.selectedComponent
      );
    }
  }

  private initializeHidePlannedProjects(): void {
    const hidePlannedProjectsString = localStorage.getItem(
      AdminPlanningContainerComponent.HIDE_PLANNED_PROJECTS_KEY
    );
    this.hidePlannedProjects =
      hidePlannedProjectsString == null
        ? false
        : hidePlannedProjectsString == 'true';
  }

  setSelectedComponent(selectedComponent: string): void {
    this.selectedComponent = selectedComponent;
    localStorage.setItem(
      AdminPlanningContainerComponent.SELECTED_COMPONENT_KEY,
      selectedComponent
    );
  }

  hidePlannedProjectsChange(): void {
    localStorage.setItem(
      AdminPlanningContainerComponent.HIDE_PLANNED_PROJECTS_KEY,
      String(this.hidePlannedProjects)
    );
  }
}
